import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ESSAIS_UI, pickLang } from "@/lib/essaisText";
import { EssaiCard } from "@/pages/Essais";

export function EssaisTeaser() {
  const { i18n } = useTranslation();
  const lang = pickLang(i18n.language);
  const U = ESSAIS_UI[lang];
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/essais", { params: { lang } }).then(({ data }) => setList(data.slice(0, 3))).catch(() => {}); }, [lang]);
  if (!list.length) return null;

  return (
    <section className="max-w-6xl mx-auto px-6 py-16 relative z-10" data-testid="essais-teaser">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-3">{U.kicker}</p>
          <h2 className="font-display text-3xl sm:text-4xl leading-tight">{U.series}</h2>
          <p className="mt-4 text-foreground/65 text-sm md:text-base">{U.lead}</p>
        </div>
        <Link to="/essais" className="inline-flex items-center gap-2 rounded-full border border-primary/40 px-5 py-2.5 text-sm text-primary hover:bg-primary/10 transition-colors shrink-0" data-testid="essais-teaser-all-link">{U.all} <ArrowRight size={15} /></Link>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((e, i) => <EssaiCard key={e.slug} e={e} U={U} i={i} />)}
      </div>
    </section>
  );
}
